import React from "react";
import { TextField } from "cayo.ui";
import { Checkbox } from "@fluentui/react";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { teamsWizardMessages } from "../messages";

type ConfigureTeamsProps = {
  team: string;
  channel: string;
  mentionTeam: boolean;
  mentionChannel: boolean;
  handleChange: (key: string, value: string | boolean) => void;
};

export const ConfigureTeams = ({
  team,
  channel,
  mentionTeam,
  mentionChannel,
  handleChange,
}: ConfigureTeamsProps) => {
  const intl = useIntl();

  return (
    <div>
      <TextField
        label={intl.formatMessage(teamsWizardMessages.teamField)}
        required
        value={team}
        setValue={(value) => handleChange("team", value)}
      />

      <TextField
        label={intl.formatMessage(teamsWizardMessages.channelField)}
        required
        value={channel}
        setValue={(value) => handleChange("channel", value)}
      />

      <CheckBoxesWrap>
        <Checkbox
          required
          checked={mentionTeam}
          id="mentionTeam"
          label={intl.formatMessage(teamsWizardMessages.mentionTeam)}
          onChange={(_, checked) => handleChange("mentionTeam", !!checked)}
        />

        <Checkbox
          required
          checked={mentionChannel}
          id="mentionChannel"
          label={intl.formatMessage(teamsWizardMessages.mentionChannel)}
          onChange={(_, checked) => handleChange("mentionChannel", !!checked)}
        />
      </CheckBoxesWrap>
    </div>
  );
};

const CheckBoxesWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px 0;
`;
